import Experiment from '@mc/experiments-react'
import { useTranslation } from '@mc/i18n'
import { SUBSCRIPTION_SIGNUP_HREF } from 'pages/certificates/annualpass/data/subscriptionData'
import {
  SignupBannerCta,
  type SignupBannerCtaProps,
} from 'pages/certificates/components/PromoBanner/SignupBannerCta'
import { TrackingAttributes } from 'pages/certificates/tracking'
import { MCCERTS_2972_SUBS_ONLY_CLP_FLAG } from './constants'
import {
  type SubsOnlyClpExpEligibilityProps,
  useSubsOnlyClpExpBucket,
} from './utils/useIsSubsOnlyClpExpActive'

type BannerCtaProps = Pick<SignupBannerCtaProps, 'kind' | 'arrowTheme'>

const PassBannerCta = (props: BannerCtaProps) => {
  const { t } = useTranslation('@mc/certificates')

  return (
    <SignupBannerCta
      {...props}
      href={SUBSCRIPTION_SIGNUP_HREF}
      text={t('marketingPages.subscription.hero.cta')}
      // purchaseClick action pinned to its historical value (see SubscriptionSignUpCTA)
      action='Get All Courses'
    />
  )
}

export const CMBannerCtaSubsOnlyExp = ({
  program,
  engagement,
  isPaintedDoor,
  ...ctaProps
}: BannerCtaProps & SubsOnlyClpExpEligibilityProps) => {
  const bucket = useSubsOnlyClpExpBucket({
    program,
    engagement,
    isPaintedDoor,
  })
  if (!bucket) {
    return <SignupBannerCta {...ctaProps} />
  }

  return (
    <TrackingAttributes variant={bucket}>
      {/* track={false}: the page-level TrackExperimentViewed owns the exposure */}
      <Experiment<BannerCtaProps>
        {...ctaProps}
        name={MCCERTS_2972_SUBS_ONLY_CLP_FLAG}
        track={false}
        default={SignupBannerCta}
        variant_1={PassBannerCta}
        variant_2={PassBannerCta}
        variant_3={PassBannerCta}
      />
    </TrackingAttributes>
  )
}
